import React from 'react'
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';

export default function AddFilterCriteriaCard(props) {
    return (
        <React.Fragment>
            <Link to="/settings/product-filters/add" className="app-card mb-3 mb-lg-4 add-criteria">
                <div className="product-filter-card">
                    <div className="card-content align-items-center">
                        <div className="d-flex align-items-center">
                            <div className="card-icon">
                                <span className="icon_">
                                    <FeatherIcon
                                        icon="plus"
                                        size="46"
                                        className="icon me-2 text-primary" />
                                </span>
                            </div>
                            <div className="card-text">
                                <div className="card-header_">
                                    <span>Add new criteria</span>
                                </div>
                                <div className="card-description">
                                    <div>Add new filter criteria to offer your customers more ways to filter products.</div>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex">
                            <div>
                                <button
                                    type="submit"
                                    className="st-btn st-btn-primary st-fw-600 st-btn-xs text-capitalize d-flex align-items-center justify-content-center"
                                >
                                    <FeatherIcon
                                        icon="plus"
                                        size="18"
                                        className="icon me-2" />
                                    <span>Add Filter Criteria</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Link>
        </React.Fragment>
    )
}